import { render, staticRenderFns } from "./CannedTextForm.vue?vue&type=template&id=5652e4ce"
import script from "./CannedTextForm.vue?vue&type=script&lang=js"
export * from "./CannedTextForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports